//Props Validations
import PropTypes from "prop-types";
import Select from "react-select";

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 5,
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 5,
    }),
    control: (base) => ({
        ...base,
        minHeight: "30px", // Adjust height as needed
        height: "30px",
        padding: 0,
        margin: 0,
        boxShadow: "none", // Remove shadow if necessary
        border: "1px solid #1976d2cc", // Border color set to #1976d2 with 80% opacity
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "0 6px", // Remove extra padding
        margin: 0,
        fontSize: "11px",
        color: "#005eef",
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        fontSize: "11px",
        color: "#005eef",
    }),
    singleValue: (base) => ({
        ...base,
        padding: 0,
        margin: 0,
        color: "#005eef",
    }),
    indicatorContainer: (base) => ({
        ...base,
        padding: 0,
        margin: 0,
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: 0,
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: 0,
        margin: 0,
    }),
    option: (base, { isSelected }) => ({
        ...base,
        padding: "5px 10px", // You can adjust padding inside options
        fontSize: "11px",
        color: isSelected ? "#ffffff" : "#005eef", // Set selected option text color to white, others to #005eef
        backgroundColor: isSelected ? "#005eef" : "transparent", // Optional: Change background color of selected option
        cursor: "pointer", // Change cursor to pointer
        "&:hover": {
            backgroundColor: "#e0e0e0", // Change background color on hover
            color: "#005eef", // Optionally change text color on hover
        },
    }),
};
const DataViewSelector = ({ value = {}, setValue = () => {}, options = [] }) => {
    const handleChange = (selectedOption) => {
        setValue(selectedOption);
        // Dispatch the action to update the data view state in the store
        // dispatch(loadDataViewState(selectedOption.value));
    };

    return (
        <div
            style={{
                minWidth: "200px", // Adjust width as needed
                marginRight: "10px", // Add margin to the right for spacing
            }}
        >
            <Select
                value={value}
                placeholder={"Data View"}
                options={options}
                onChange={handleChange}
                styles={customStyles}
                isSearchable={false}
            />
        </div>
    );
};

DataViewSelector.propTypes = {
    value: PropTypes.object,
    setValue: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.object),
};

export default DataViewSelector;
